export const footerLinks = [
  {
    id:1,
    title: 'Coliving in Spain',
    url: '/spain',
    label: 'Spain'
  },
  {
    id:2,
    title: 'Coliving in France',
    url: '/france',
    label: 'France'
  },
  {
    id:3,
    title: 'Coliving in Italy',
    url: '/italy',
    label: 'Italy'
  },
  {
    id:4,
    title: 'Coliving in Portugal',
    url: '/portugal',
    label: 'Portugal'
  },
  {
    id:5,
    title: 'Coliving in Germany',
    url: '/germany',
    label: 'Germany'
  }
];
